// Journal de l'écran Synchronisation : saisies écartées ou abandonnées
const MAX_ENTRIES = 200;

export const createSyncLog = (db) => ({
    add: (entry) => db.transaction('rw', db.syncLog, async () => {
        await db.syncLog.add({ ...entry, at: new Date().toISOString() });
        const count = await db.syncLog.count();
        if (count > MAX_ENTRIES) {
            const oldestIds = await db.syncLog.orderBy('id').limit(count - MAX_ENTRIES).primaryKeys();
            await db.syncLog.bulkDelete(oldestIds);
        }
    }),
    list: () => db.syncLog.orderBy('id').reverse().toArray(),
    clear: () => db.syncLog.clear()
});
